<template>
  <div>
    <div class="listContent">
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          v-if="userRoleList.indexOf('menu-31f89c034e8748d39c1ac9d6abcd2287')>-1"
          >添加型号</el-button
        >
        <el-button
          type="info"
          @click="deleteSignAll(deleteStr)"
          plain
          v-if="userRoleList.indexOf('menu-31f89c034e8748d39c1ac9d6abcd2287')>-1"
          >删除</el-button
        >
        <span class="searchInputText">型号名称</span>
        <el-input placeholder="请输入型号名称" v-model="search.model"></el-input>
        <el-button type="danger" @click="doSearch">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>

      <div class="listContain equipmentList">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            :row-key="fieldKey"
            @selection-change="handleSelectionChange"
            ref="tb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="model"
              label="型号名称"
              width=""
            ></el-table-column>
            <el-table-column prop="type" label="设备类型" width="">
            <template slot-scope="scope">
              <span>{{typeName(scope.row.type,equipTypeList)}}</span> 
            </template>
            </el-table-column>
            <el-table-column
              prop="createDate"
              label="型号创建时间"
              width=""
            ></el-table-column>

            <el-table-column label="操作" width>
              <template slot-scope="scope">
                <span class="lookMore" @click="openModbox1(scope.row);islook=false" v-if="userRoleList.indexOf('menu-31f89c034e8748d39c1ac9d6abcd2287')>-1">修改</span>
                <span
                  class="lookMore"
                  @click="openReadbox1(scope.row);islook=true"
                  >查看</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      :title="actionName"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
      custom-class="addDeviceType"
      @close="closeDialog"
    >
      <div class="borderBlock borderPadding addAndEdit" v-if="formShow">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
        >
          <el-form-item label="设备型号名称：" required prop="model">
            <el-input :disabled='islook' class="shotType" v-model="modelObj.model" maxlength="20" placeholder="请输入设备型号名称"></el-input>
          </el-form-item>
          <el-form-item label="设备类型：" required prop="type">
                <el-select :disabled="islook" v-model="modelObj.type" multiple collapse-tags placeholder="请选择设备类型" class="shotType" @change="typeChange">
                    <el-option
                    v-for="item in equipTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="品牌：" required prop="brand">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.brand" maxlength="20" placeholder="请输入品牌"></el-input>
          </el-form-item>
          <el-form-item label="目标日均工作时长(H)：" required prop="targetDuration">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.targetDuration" maxlength="2" placeholder="请输入目标日均工作时长(H)"></el-input>
          </el-form-item>
          <el-form-item label="吨位(t)：" required prop="tonnage" v-if="!(type[0]==27||type[0]==28||type[0]==35)">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.tonnage"  placeholder="请输入吨位(t)"></el-input>
          </el-form-item>
          <el-form-item label="车身外壳长度(m)：" required prop="equipLength" v-if="type[0]!=35">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.equipLength"  placeholder="请输入车身外壳长度:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="车身外壳宽度(m)：" required prop="equipWidth" v-if="type[0]!=35">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.equipWidth"  placeholder="请输入车身外壳宽度:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="GPS离车头距离(m)：" required prop="gpsHead" v-if="type[0]!=35">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.gpsHead"  placeholder="请输入GPS离车头距离:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="GPS离右侧距离(m)：" required prop="gpsRight" v-if="type[0]!=35">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.gpsRight"  placeholder="请输入GPS离右侧距离:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="前轮宽度(m)：" required prop="wheelHeadWidth" v-if="!(type[0]==27||type[0]==28||type[0]==35)">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.wheelHeadWidth"  placeholder="请输入前轮宽度:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="后轮宽度(m)：" required prop="wheelBackWidth" v-if="!(type[0]==27||type[0]==28||type[0]==35)">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.wheelBackWidth"  placeholder="请输入后轮宽度:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="熨平板宽度(m)：" required prop="wheelBackWidth" v-if="type[0]==27||type[0]==28">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.wheelBackWidth"  placeholder="请输入熨平板宽度:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="前后轮的间隔(m)：" required prop="wheelGap" v-if="!(type[0]==27||type[0]==28||type[0]==35)">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.wheelGap"  placeholder="请输入前后轮的间隔:单位(m)"></el-input>
          </el-form-item>
          <el-form-item label="铣刨宽度 (mm)：" required prop="millingWidth" v-if="type[0]==35">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.millingWidth"  placeholder="请输入铣刨宽度:单位(mm)"></el-input>
          </el-form-item>
          <el-form-item label="油箱容积(L)：" required prop="oilCapacity">
              <el-input :disabled="islook" class="shotType" v-model="modelObj.oilCapacity"  placeholder="请输入油箱容积:单位(L)"></el-input>
          </el-form-item>
          <div style="clear: both"></div>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$refs.addModForm.resetFields();addModBoxVisible = false;islook=false;">取消</el-button>
        <el-button type="primary" @click="addModConfirm();islook=false" v-show="!islook">{{
          actionName
        }}</el-button>
        <el-button type="primary" @click="$refs.addModForm.resetFields();addModBoxVisible=false;islook=false;" v-show="islook">
          确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSysEquipModels,
  getEquipTypeList,
  putSysEquipModel as modPut,
  addSysEquipModel as addPost,
  delSysEquipModel as delPut,
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      fieldKey: "ids",
      fieldRowName: "name",
      arrowList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "系统设置",
          path: "/transfer/organize",
        },
        {
          name: "型号管理",
          path: "",
        },
      ],
      search: {},
      modelObj: {},
      type:[],
      actionName: "",
      islook:false,
      dataList: [],
      equipTypeList: [],
      activeObj: "",
      deleteStr: "",
      checkedKeys: [],
      actionNameN: '',
      roleValue: '',
      restaurants: '',
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      formShow:true,
      userRoleList: localStorage.getItem("userRoleList")
    };
  },
  computed: {
    rules: function () {
      return {
        model: [{ required: true, message: "必填" }],
        type: [{ required: true, message: "必填" }],
        brand: [{ required: true, message: "必填" }],
        targetDuration: [{ required: true, message: "必填" }],
        tonnage: [{ required: true, message: "必填" }],
        equipLength: [{ required: true, message: "必填" }],
        equipWidth: [{ required: true, message: "必填" }],
        gpsHead: [{ required: true, message: "必填" }],
        gpsRight: [{ required: true, message: "必填" }],
        wheelHeadWidth: [{ required: true, message: "必填" }],
        wheelBackWidth: [{ required: true, message: "必填" }],
        wheelGap: [{ required: true, message: "必填" }],
        oilCapacity:[{ required: true, message: "必填" }],
        millingWidth:[{ required: true, message: "必填" }],
      };
    },
    typeName:()=>{
      return (type,equipTypeList)=>{
        let arr = (type+'').split(',')
        let str=''
        arr.map(i=>{
          equipTypeList.map(j=>{
            if(i==j.id){
              str+=j.name+','
            }
          })
        })
        return str.substr(0,str.length-1)
      }
    }
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.getDataList()
  },
  methods: {
    addPost,
    modPut,
    delPut,
    getDataList: function (params) {
      //获取设备类型
      getEquipTypeList({ pageSize: 100 }).then((res1) => {
        this.equipTypeList = res1.data.content.list;
        console.log(this.equipTypeList,'this.equipTypeList')
        getSysEquipModels(params).then((res) => {
          this.pageMsg = this.pageAssign(res.data.content);
          this.dataList = res.data.content.list;
          // this.dataList.map(i=>{
          //   this.equipTypeList.map(j=>{
          //     j.id=j.id+''
          //     if(i.type==j.id){
          //       i.typeName=j.name
          //     }
          //   })
          // })
        });
      });
    },
    //关闭dialog
    closeDialog(){
      this.modelObj.type=[]
      this.type=[]
      this.$refs.addModForm.resetFields();
      this.addModBoxVisible = false;
      this.islook=false;
    },
    typeChange(e){
      this.formShow=false;
      this.formShow=true;
      this.type=e
      console.log(e)
    },
    handleSelectionChange(selection) {
      console.log(selection);
      let deleteArr= []
      for(let i=0;i<selection.length;i++){
          deleteArr.push(selection[i].id)
      }
      this.deleteStr = deleteArr.join(",")
    },
    addModConfirm: function(){
        this.modelObj.type=this.modelObj.type.join(',')
        this.addModSubmit()
    },
  },
  components: {
    ElPageCover,
  },
};
</script>

<style lang="scss">
.addDeviceType{
  width: 700px !important;
  .addAndEdit { 
    .el-form-item{
      width: 700px !important;
      margin-bottom: 10px !important;
    }
    .el-form-item__label{
      width: 200px !important;
      padding-left: 30px !important;
    }
    .el-form-item__content{
      .el-select{
        .el-select__tags{
          margin-left: 20px;
        }
      }
    }
    .el-form-item__error{
      padding-top: 0 !important;
    }
    .el-input {
      width: 380px !important;
      height: 36px !important;
      margin-left: 23px;
      margin-right: 23px;
      font-size: 14px !important;
      .el-input__inner {
        width: 380px !important;
        height: 36px !important;
        border-radius: 1px !important;
      }
    }
  }
}

</style>
<style lang="scss" scoped="">
.imgShow {
  height: 950px;
  width: 100%;
  background-image: url("../../images/all/applyImg.png");
  background-size: 100% 100%;
}
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
</style>